<template>
  <div class="stay-receive-list">
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <!-- <el-form-item label="ERP订单编号:" prop="ERPNumber">
        <el-input v-model.trim="searchForm.ERPNumber" placeholder="请输入ERP订单编号" />
      </el-form-item> -->
      <el-form-item label="合同编号:" prop="ContractNumber">
        <el-input v-model.trim="searchForm.ContractNumber" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" placeholder="请输入合同编号" @blur="salaryChange" />
      </el-form-item>
      <el-form-item label="发货单号:" prop="ReceiptNumber">
        <el-input v-model.trim="searchForm.ReceiptNumber" placeholder="请输入发货单号" />
      </el-form-item>
      <el-form-item label="发货时间:" prop="BeginReceiptDate">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.BeginReceiptDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.EndReceiptDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
        </div>
      </el-form-item>
      <!-- <el-form-item label="导出时间:">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              type="date"
              v-model="DcBeginReceiptDate"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              @change="handleStartCustomerExpectedDateChange"
              :picker-options="startCustomerExpectedDatePickerOptions"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">-</div>
          <div class="rj-flex__item">
            <el-date-picker
              type="date"
              v-model="DcEndReceiptDate"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              @change="handleEndCustomerExpectedDateChange"
              :picker-options="endCustomerExpectedDatePickerOptions"
            />
          </div>
        </div>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" :loading="tableLoading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <div class="operate-btn-wrap">
      <!-- 导出功能 -->
      <el-button type="primary" :loading="loadingBackList" @click="exPortBackList()">
        批量下载回执单
      </el-button>
      <el-button type="default" @click="exPort()">
        导出发货明细
      </el-button>
    </div>

    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <!-- <el-table-column prop="ERPNumber" label="ERP订单编号" align="left" width="130" /> -->
        <el-table-column prop="ContractNumber" label="合同编号" align="left" width="150" />
        <el-table-column prop="ObjectName" label="项目名称" align="left" min-width="140" />
        <el-table-column prop="ReceiptAddress" label="收货地址" align="left" min-width="150" />
        <el-table-column prop="IntegratorsName" label="首级集成商名称" align="left" min-width="150" />
        <el-table-column prop="LogisticsCompany" label="物流公司" align="left" width="150" />
        <el-table-column prop="ReceiptNumber" label="发货单号" align="left" width="130">
          <template v-slot="{row}">
            <el-button type="text" class="el-btn-text-left" @click="detailProductList(row)">
              {{ row.ReceiptNumber }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="ReceiptDate" label="发货日期" align="left" width="100" />
        <el-table-column prop="FreightNumber" label="货运单号" align="left" width="120" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" class="el-btn-text-left" @click="logistClick(row)">
              {{ row.FreightNumber }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="回单" align="left" width="90" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" @click="toReceiptList(row)">
              查看及上传
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="操作" width="90" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" @click="comfirmReceipt(row)">
              确认收货
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <a ref="downTag" :href="exportUrl" target="_blank" />
    <el-dialog title="发货产品清单" :visible.sync="receiptProductVisible" width="800px">
      <delivery-receipt-product-list
        v-if="receiptProductVisible"
        :receipt-number="receiptNumber"
        :contract-code="contractCode"
        :order-number="orderNumber"
      />
    </el-dialog>
    <el-dialog title="回单信息" :visible.sync="receiptVisible" width="700px">
      <receipt-list v-if="receiptVisible" :receipt-form="receiptForm" :is-show="isShow" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="receiptVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <logisticsNumber :dialog-form-visible-logist="dialogFormVisibleLogist" :form="formNum" @on-status-dialog="updataDialogFormVisibleLogist" />
  </div>
</template>

<script>
import { getDeliveryReceiptByProductList, getDeliveryReceiptList, comfirmReceipt, batchExportEnclosureList, getTokenForDownZipV2 } from '@/API/index.js';
import eventBus from '@/libs/eventBus.js';
import deliveryReceiptProductList from './deliveryReceiptProductList';
import receiptList from './receiptList';
import logisticsNumber from '../../partShipCheck/logisticsNumber';
export default {
  name: 'StayReceiveList',
  data () {
    return {
      tableLoading: false,
      loadingBackList: false,
      receiptProductVisible: false,
      searchForm: {
        // ERPNumber: '',
        ContractNumber: '',
        ReceiptNumber: '',
        BeginReceiptDate: '',
        EndReceiptDate: ''
      },
      formNum: {},
      dialogFormVisibleLogist: false,
      fileserveDownUrl: '',
      // token: '',
      DcBeginReceiptDate: null,
      DcEndReceiptDate: null,
      exportUrl: '',
      tableData: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 100
      },
      receiptNumber: '',
      contractCode: '',
      orderNumber: '',
      receiptVisible: false,
      receiptForm: {},
      isShow: true,
      startCustomerExpectedDatePickerOptions: {
        disabledDate (time) {
          return null;
        }
      },
      endCustomerExpectedDatePickerOptions: {
        disabledDate (time) {
          return null;
        }
      }
    };
  },
  components: {
    deliveryReceiptProductList,
    receiptList,
    logisticsNumber
  },
  methods: {
    // 客户期望日 结束时间 起始值
    handleStartCustomerExpectedDateChange (val) {
      // debugger;
      if (val === null) {
        this.endCustomerExpectedDatePickerOptions = {
          disabledDate (time) {
            return null;
          }
        };
        return;
      }
      this.endCustomerExpectedDatePickerOptions = {
        disabledDate (time) {
          return time.getTime() > new Date(val).getTime() + 3600 * 1000 * 24 * 6;
        }
      };
    },
    // 客户期望日 开始时间 结束值
    handleEndCustomerExpectedDateChange (val) {
      if (val === null) {
        this.startCustomerExpectedDatePickerOptions = {
          disabledDate (time) {
            return null;
          }
        };
        return;
      }
      this.startCustomerExpectedDatePickerOptions = {
        disabledDate (time) {
          return time.getTime() < new Date(val).getTime() - 3600 * 1000 * 24 * 7;
        }
      };
    },
    // blur
    salaryChange (e) {
      this.searchForm.ContractNumber = (e.target.value || '').trim();
    },
    logistClick (row) {
      this.formNum = row;
      this.dialogFormVisibleLogist = true;
    },
    // 组件事件
    updataDialogFormVisibleLogist (val) {
      this.dialogFormVisibleLogist = val;
    },
    initData () {
      this.tableLoading = true;
      let params = {
        StateClass: 1,
        // ERPNumber: this.searchForm.ERPNumber,
        ContractNumber: this.searchForm.ContractNumber,
        ReceiptNumber: this.searchForm.ReceiptNumber,
        BeginReceiptDate: this.searchForm.BeginReceiptDate,
        EndReceiptDate: this.searchForm.EndReceiptDate,
        PageSize: this.page.pageSize,
        PageIndex: this.page.currentPage - 1
      };
      getDeliveryReceiptList(params).then((res) => {
        let json = res.data;
        if (json.status === '200' && json.data.dt) {
          this.tableLoading = false;
          this.page.currentPage = json.data.PageIndex + 1;
          this.page.total = json.data.TotalCount;
          this.tableData = json.data.dt;
        } else {
          this.tableData = [];
          this.page.currentPage = 1;
          this.page.total = 0;
        }
      }).catch((res) => {
        this.tableLoading = false;
      });
    },
    // 导出按钮
    exPort () {
      if (!this.searchForm.BeginReceiptDate || !this.searchForm.EndReceiptDate) {
        this.$message.error('请输入发货时间');
        return;
      }
      getDeliveryReceiptByProductList(this.searchForm.BeginReceiptDate, this.searchForm.EndReceiptDate).then((res) => {
        this.submitLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileName = '发货明细' + new Date().toLocaleString() + '.xlsx';
        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {});
    },
    getZip (fileIds) {
      getTokenForDownZipV2({
        catalogName: '附件集合',
        files: fileIds
      }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.downzipFile(json.data.token, json.data.downloadZipUrl);
        }
      }).catch(() => {

      });
    },
    // initToken () {
    //   attachmentGetToken().then((res) => {
    //     let json = res.data;
    //     if (json.status === '200') {
    //       this.token = json.data.token;
    //     }
    //   }).catch(() => {

    //   });
    // },
    downzipFile (token, url) {
      this.exportUrl = url + `?Token=${token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    exPortBackList () {
      if (!this.searchForm.BeginReceiptDate && !this.searchForm.EndReceiptDate && !this.searchForm.ContractNumber && !this.searchForm.ReceiptNumbe) {
        this.$message.error('请输入导出条件');
        return;
      }
      let params = {
        ContractNumber: this.searchForm.ContractNumber,
        ReceiptNumber: this.searchForm.ReceiptNumber,
        BeginReceiptDate: this.searchForm.BeginReceiptDate,
        EndReceiptDate: this.searchForm.EndReceiptDate
      };
      this.loadingBackList = true;
      batchExportEnclosureList(params).then((res) => {
        let json = res.data;
        this.loadingBackList = false;
        if (json.status === '200') {
          if (JSON.stringify(json.data) === '{}') {
            this.$message.error('当前条件下无数据');
          } else if (Object.keys(json.data).length > 200) {
            this.$message.error('下载文件数量过多，请缩小下载文件范围');
          } else {
            this.getZip(json.data);
          }
        } else {
        }
      }).catch((res) => {
        this.loadingBackList = false;
      });
    },
    resetForm () {
      this.$refs['searchForm'].resetFields();
      this.searchForm.EndReceiptDate = '';
      this.DcBeginReceiptDate = null;
      this.DcEndReceiptDate = null;
      this.page.currentPage = 1;
      this.initData();
    },
    doSearch () {
      this.page.currentPage = 1;
      this.initData();
    },
    comfirmReceipt (row) {
      this.$confirm('确认是否收货?', '提示', {
        confirmButtonText: '收货',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          ReceiptNumber: row.ReceiptNumber,
          State: '2'
        };
        comfirmReceipt(params).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$message({
              type: 'success',
              message: '确认收货成功!'
            });
            this.searchForm.currentPage = 1;
            this.initData();
            this.$nextTick(() => {
              eventBus.$emit('changescom');
            });
          }
        }).catch((res) => {
          this.$message({
            type: 'warning',
            message: '确认收货失败!'
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    detailProductList (row) {
      this.receiptProductVisible = true;
      this.receiptNumber = row.ReceiptNumber;
      this.contractCode = row.ContractNumber;
      this.orderNumber = row.ERPNumber;
    },
    handerSizeChange () {
      this.page.currentPage = 1;
      this.initData();
    },
    handerCurrentChange () {
      this.initData();
    },
    pickerOptions () {

    },
    toReceiptList (row) {
      this.receiptVisible = true;
      this.receiptForm = row;
    }

  },
  mounted () {
    this.initData();
    // this.initToken();
  }
};
</script>

<style scoped>

</style>
